/**
 * ValidateSpanishID. Returns the type of document and checks its validity.
 *
 * Usage:
 *     ValidateSpanishID( str )
 *
 *     > ValidateSpanishID( '12345678Z' )
 *     // { type: 'dni', valid: true }
 *
 *     > ValidateSpanishID( 'B83375575' )
 *     // { type: 'cif', valid: false }
 *
 * The algorithm is adapted from other solutions found at:
 * - http://www.compartecodigo.com/javascript/validar-nif-cif-nie-segun-ley-vigente-31.html
 * - http://es.wikipedia.org/wiki/C%C3%B3digo_de_identificaci%C3%B3n_fiscal
 */

const DNI_REGEX = /^(\d{8})([A-Z])$/
const CIF_REGEX = /^([ABCDEFGHJKLMNPQRSUVW])(\d{7})([0-9A-J])$/
const NIE_REGEX = /^[XYZ]\d{7,8}[A-Z]$/
const EXTRA_CASE = '9999999999'

let validateSpanishID = function (str, typeID = null) {
  // Ensure upcase and remove whitespace
  str = str.toUpperCase().replace(/\s/, '')
  let type = spainIdType(str)

  let valid = false
  switch (type) {
    case 'cif':
      valid = validCIF(str) && ['LP', 'AP'].includes(typeID)
      break
    case 'dni':
      valid = validDNI(str) && ['NP', 'AP'].includes(typeID)
      break
    case 'nie':
      valid = validNIE(str) && ['NP', 'AP'].includes(typeID)
      break
    case 'valid':
      valid = true
      break
  }
  return valid
}

let spainIdType = function (str) {
  if (str.match(DNI_REGEX)) {
    return 'dni'
  }
  if (str.match(CIF_REGEX)) {
    return 'cif'
  }
  if (str.match(NIE_REGEX)) {
    return 'nie'
  }
  if (str === EXTRA_CASE) {
    return 'valid'
  }
  return null
}

let validDNI = function (dni) {
  let dniLetters = 'TRWAGMYFPDXBNJZSQVHLCKE'
  let letter = dniLetters.charAt(parseInt(dni, 10) % 23)

  return letter === dni.charAt(8)
}

let validNIE = function (nie) {
  // Change the initial letter for the corresponding number and validate as DNI
  let niePrefix = nie.charAt(0)

  switch (niePrefix) {
    case 'X':
      niePrefix = 0
      break
    case 'Y':
      niePrefix = 1
      break
    case 'Z':
      niePrefix = 2
      break
  }

  return validDNI(niePrefix + nie.substr(1))
}

let validCIF = function (cif) {
  let match = cif.match(CIF_REGEX)
  if (!match) return false
  let letter = match[1]
  let number = match[2]
  let control = match[3]
  let evenSum = 0
  let oddSum = 0
  let n

  for (let i = 0; i < number.length; i++) {
    n = parseInt(number[i], 10)

    // Odd positions (Even index equals to odd position. i=0 equals first position)
    if (i % 2 === 0) {
      // Odd positions are multiplied first.
      n *= 2

      // If the multiplication is bigger than 10 we need to adjust
      oddSum += n < 10 ? n : n - 9

      // Even positions
      // Just sum them
    } else {
      evenSum += n
    }
  }
  let sumDigit = (evenSum + oddSum).toString().substr(-1)
  let controlDigit = sumDigit > 0 ? (10 - sumDigit) : 0
  let controlLetter = 'JABCDEFGHI'.substr(controlDigit, 1)

  let valid = false
  // Control must be a digit
  if (letter.match(/[ABEH]/)) {
    valid = Number(control) === controlDigit

    // Control must be a letter
  } else if (letter.match(/[KPQS]/)) {
    valid = control === controlLetter

    // Can be either
  } else {
    valid = Number(control) === controlDigit || control === controlLetter
  }
  return valid
}

export default validateSpanishID
